import axios from "axios";

export const slugify = (str) => {
  return str
    ? str
        .toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-")
    : "";
};

export const processHtmlContent = (html) => {
  return html
    ? html
        .replace(/<h[1-6]>/gi, "<strong>")
        .replace(/<\/h[1-6]>/gi, "</strong>")
        .replace(/<p>/gi, "<br/>")
        .replace(/<\/p>/gi, "")
        .replace(/\n/g, "<br/>")
    : "";
};

export const handleTrackClick = (clickType, metaData, storedUser) => {
  if (!storedUser.uuid) {
    console.error("User UUID is missing");
    return;
  }
  const clickData = {
    userUuid: storedUser.uuid,
    clickType,
    metaData,
  };

  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/api/clicks`, clickData)
    .then((response) => {
      console.log("Click tracked:", response.data);
    })
    .catch((error) => {
      console.error("Error tracking click:", error);
    });
};

export const columnCount = (isMobile, isTablet) => {
  const envColumnCount = parseInt(process.env.REACT_APP_SPECIAL_OFFERS_COLUMN_COUNT, 10) || 3;
  return isMobile ? 1 : isTablet ? 2 : envColumnCount;
};

export const specialOffersDescriptionMaxLength =
  parseInt(process.env.REACT_APP_SPECIAL_OFFERS_DESCRIPTION_MAX_LENGTH, 10) || 200;

export const callbackCooldownDays =
  parseInt(process.env.REACT_APP_CALLBACK_COOLDOWN_DAYS, 10) || 7;